var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.fullLoading,
          expression: "fullLoading",
          modifiers: { fullscreen: true, lock: true }
        }
      ]
    },
    [
      _c("div", { staticClass: "logo-sty" }),
      _c(
        "div",
        { staticClass: "auth-sty" },
        [
          _vm.authComplete
            ? _c(
                "div",
                { staticClass: "result-sty" },
                [
                  _c(
                    "el-result",
                    {
                      attrs: {
                        icon: "success",
                        title: "授权成功",
                        subTitle: ""
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "extra" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "medium" },
                              on: { click: _vm.turnBack }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  "完成" +
                                    (_vm.turnCount > 0
                                      ? "（" + _vm.turnCount + "S）"
                                      : "")
                                ) + "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            : [
                _c(
                  "div",
                  { staticClass: "content-box" },
                  [
                    _vm._m(0),
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c("p", { staticClass: "res-titleII" }, [
                          _vm._v(
                            _vm._s(
                              "您" +
                                (_vm.authInfo && _vm.authInfo.userType == 1
                                  ? "的企业"
                                  : "") +
                                "正在通过（" +
                                _vm.authInfo.creator.username +
                                "）的平台上申请开通"
                            )
                          ),
                          _c("span", { staticClass: "res-span" }, [
                            _vm._v("电子签名服务，请完成授权。")
                          ])
                        ]),
                        _c("h1", { staticStyle: { "margin-bottom": "10px" } }, [
                          _vm._v(
                            "确认授权后 （" +
                              _vm._s(_vm.authInfo.creator.username) +
                              "）将获得以下权限："
                          )
                        ]),
                        _vm.authInfo && _vm.authInfo.userType == 1
                          ? [
                              _c("p", { staticClass: "auth-item" }, [
                                _vm._v("获取您的企业基本信息")
                              ]),
                              _c("p", { staticClass: "auth-item" }, [
                                _vm._v(
                                  "授权访问您的电子签数据：合同数据、下载签署文件、签署任务信息、签署任务创建及发起、印章管理"
                                )
                              ]),
                              _c("p", { staticClass: "auth-item" }, [
                                _vm._v("授权管理并使用您的秘钥（AppKey）")
                              ])
                            ]
                          : [
                              _c("p", { staticClass: "auth-item" }, [
                                _vm._v("获取您的身份信息")
                              ]),
                              _c("p", { staticClass: "auth-item" }, [
                                _vm._v(
                                  "授权访问您的电子签数据：合同数据、下载签署文件、签署任务信息、签署任务创建及发起"
                                )
                              ])
                            ],
                        _vm.authInfo.linkType === 2
                          ? [
                              _c(
                                "h1",
                                [
                                  _c("span", [_vm._v("验证方式：")]),
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: "请选择" },
                                      on: { change: _vm.ChangeFn },
                                      model: {
                                        value: _vm.activeNav,
                                        callback: function($$v) {
                                          _vm.activeNav = $$v
                                        },
                                        expression: "activeNav"
                                      }
                                    },
                                    _vm._l(_vm.options, function(item) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.label,
                                          value: item.key
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                [
                                  _vm.activeNav === 1
                                    ? [
                                        _c("h1", [_vm._v("授权账户：")]),
                                        _c(
                                          "p",
                                          { staticStyle: { margin: "2% 0" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.accountInfo.referEmail ||
                                                  _vm.accountInfo.referMobile
                                              )
                                            ),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.accountInfo.name ||
                                                      _vm.authInfo.name,
                                                    expression:
                                                      "accountInfo.name || authInfo.name"
                                                  }
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    "（" +
                                                      (_vm.accountInfo.name ||
                                                        _vm.authInfo.name) +
                                                      "）"
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-input",
                                          {
                                            staticClass: "code-input-sty",
                                            attrs: {
                                              placeholder: "请输入内容",
                                              size: "small"
                                            },
                                            model: {
                                              value: _vm.AuthCode,
                                              callback: function($$v) {
                                                _vm.AuthCode = $$v
                                              },
                                              expression: "AuthCode"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  slot: "append",
                                                  disabled: _vm.isCountDown
                                                },
                                                on: { click: _vm.verifyHandle },
                                                slot: "append"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.isCountDown
                                                      ? _vm.codeCountDown + " S"
                                                      : "获取验证码"
                                                  ) + "\n                    "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : _vm.activeNav === 2
                                    ? [
                                        _c("h1", [_vm._v("授权账户：")]),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              margin: "2px 0 12px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.accountInfo.referEmail ||
                                                  _vm.accountInfo.referMobile
                                              )
                                            ),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.accountInfo.name ||
                                                      _vm.authInfo.name,
                                                    expression:
                                                      "accountInfo.name || authInfo.name"
                                                  }
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    "（" +
                                                      (_vm.accountInfo.name ||
                                                        _vm.authInfo.name) +
                                                      "）"
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c("h1", [_vm._v("法定代表人姓名：")]),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              margin: "2px 0 12px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.authInfo.lbLegalName)
                                            )
                                          ]
                                        ),
                                        _c("h1", [
                                          _vm._v("法定代表人身份证号：")
                                        ]),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              margin: "2px 0 12px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.authInfo.lbLegalIdentityCard
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm.activeNav === 3
                                    ? [
                                        _c("h1", [
                                          _vm._v(
                                            "授权账户：" +
                                              _vm._s(
                                                _vm.accountInfo.referEmail ||
                                                  _vm.accountInfo.referMobile
                                              )
                                          ),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.accountInfo.name ||
                                                    _vm.authInfo.name,
                                                  expression:
                                                    "accountInfo.name || authInfo.name"
                                                }
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "（" +
                                                    (_vm.accountInfo.name ||
                                                      _vm.authInfo.name) +
                                                    "）"
                                                )
                                              )
                                            ]
                                          )
                                        ]),
                                        _c(
                                          "ul",
                                          { staticClass: "submit_list" },
                                          [
                                            _c(
                                              "li",
                                              {
                                                class: [
                                                  "list_once",
                                                  {
                                                    active:
                                                      _vm.activeTableSecond ===
                                                      1
                                                  }
                                                ],
                                                on: {
                                                  click: function($event) {
                                                    return _vm.activeTableSecondFn(
                                                      1
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", {
                                                  staticClass: "radio"
                                                }),
                                                _c("span", [
                                                  _vm._v("分享二维码/链接")
                                                ])
                                              ]
                                            ),
                                            _c(
                                              "li",
                                              {
                                                class: [
                                                  "list_once list_once2",
                                                  {
                                                    active:
                                                      _vm.activeTableSecond ===
                                                      2
                                                  }
                                                ],
                                                on: {
                                                  click: function($event) {
                                                    return _vm.activeTableSecondFn(
                                                      2
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", {
                                                  staticClass: "radio"
                                                }),
                                                _c("span", [
                                                  _vm._v("直接发送短信")
                                                ])
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.activeTableSecond === 1,
                                                expression:
                                                  "activeTableSecond === 1"
                                              }
                                            ],
                                            staticClass: "qrcode_box"
                                          },
                                          [
                                            _c("qrcode", {
                                              key: "evidence",
                                              attrs: {
                                                value: _vm.QRCodeValue,
                                                size: 140,
                                                leave: "H"
                                              }
                                            }),
                                            _c(
                                              "div",
                                              { staticClass: "qrcode_btn" },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticClass:
                                                      "qrcode_href_copy",
                                                    attrs: {
                                                      "data-clipboard-text":
                                                        _vm.QRCodeValue,
                                                      size: "small"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.copyHrefFn(
                                                          ".qrcode_href_copy"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("复制链接")]
                                                ),
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "danger",
                                                      size: "small"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.getProfileFn(
                                                          1
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("查询认证结果")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.activeTableSecond === 2,
                                                expression:
                                                  "activeTableSecond === 2"
                                              }
                                            ],
                                            staticClass: "sms_box"
                                          },
                                          [
                                            _vm.smsAuthVisible
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "sms_loading"
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-time",
                                                      staticStyle: {
                                                        color: "#ec1c1c",
                                                        "font-size": "38px",
                                                        "font-weight": "bold"
                                                      }
                                                    }),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticStyle: {
                                                          margin: "20px 0"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        已向法定代表人 " +
                                                            _vm._s(
                                                              _vm.authInfo
                                                                .lbLegalName
                                                            ) +
                                                            "发送认证短信，请及时通知法定代表人完成认证！\n                      "
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              size: "small"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.smsAgainFn(
                                                                  0
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("修改手机号")]
                                                        ),
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "danger",
                                                              size: "small"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.getProfileFn(
                                                                  1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "查询认证结果"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "el-form",
                                                  {
                                                    ref: "moblieDataRef",
                                                    staticClass: "sms_form",
                                                    attrs: {
                                                      model: _vm.moblieData,
                                                      rules: _vm.phoneRules,
                                                      size: "small",
                                                      "label-width": "150px"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          prop: "smsPhone",
                                                          label:
                                                            "法定代表人手机号:"
                                                        }
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          attrs: {
                                                            maxlength: 11,
                                                            minlength: 11,
                                                            placeholder:
                                                              "法定代表人手机号"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.moblieData
                                                                .smsPhone,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.moblieData,
                                                                "smsPhone",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "moblieData.smsPhone"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        staticStyle: {
                                                          "text-align":
                                                            "center",
                                                          "padding-top": "15px"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "aliCaptcha",
                                                          {
                                                            attrs: {
                                                              verify:
                                                                _vm.getPhoneCode,
                                                              mobile:
                                                                _vm.moblieData
                                                                  .smsPhone,
                                                              verifyType:
                                                                _vm.BUSITYPE
                                                                  .LEGALPERSON,
                                                              handCallback:
                                                                _vm.handCallback
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "el-button",
                                                              {
                                                                attrs: {
                                                                  size: "small",
                                                                  type: "danger"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "确认发送"
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                          ],
                                          1
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          : [
                              _c("h1", [_vm._v("授权账户：")]),
                              _c("p", { staticStyle: { margin: "2% 0" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.accountInfo.referEmail ||
                                      _vm.accountInfo.referMobile
                                  )
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.accountInfo.name ||
                                          _vm.authInfo.name,
                                        expression:
                                          "accountInfo.name || authInfo.name"
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        "（" +
                                          (_vm.accountInfo.name ||
                                            _vm.authInfo.name) +
                                          "）"
                                      )
                                    )
                                  ]
                                )
                              ])
                            ]
                      ],
                      2
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "80%", margin: "20px 0" },
                        attrs: { type: "primary" },
                        on: { click: _vm.authConfrim }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.activeNav === 3 && _vm.activeTableSecond === 2
                              ? "已完成授权"
                              : "确认授权"
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
        ],
        2
      ),
      _c(
        "AliCaptcha",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ],
          attrs: {
            handCallback: _vm.countdownLe,
            targetId: _vm.accountInfo.emailOrPhone,
            verifyType: _vm.BUSITYPE.AuthSendVerifiy
          }
        },
        [_c("button", { ref: "aliCaptchaRef" }, [_vm._v("发送验证码")])]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "人脸识别认证",
            visible: _vm.faceCodeVisible,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.faceCodeVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "wrap" },
            [
              _c("p", { staticClass: "tip" }, [
                _vm._v("请扫描二维码或复制链接，在手机上完成人脸认证")
              ]),
              _c(
                "div",
                { staticClass: "images" },
                [
                  _c("qrcode", {
                    staticClass: "qr",
                    attrs: { value: _vm.faceAuthUrl, size: 194, level: "H" }
                  }),
                  _c("img", {
                    staticClass: "img-tip",
                    attrs: {
                      src: require("../../../../components/face-auth-qrcode/face-tip.png")
                    }
                  })
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 17 } },
                    [
                      _c("el-input", {
                        attrs: { readonly: "", value: _vm.faceAuthUrl }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticStyle: { float: "right" }, attrs: { span: 6 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "qrCodeLink",
                          attrs: {
                            "data-clipboard-text": _vm.faceAuthUrl,
                            type: "danger"
                          },
                          on: {
                            click: function($event) {
                              return _vm.copyHrefFn(".qrCodeLink")
                            }
                          }
                        },
                        [_vm._v("复制链接")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("p", { staticClass: "text-tip" }, [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "#ec1c1c" }
                }),
                _vm._v("\n          每个二维码或对应的链接只能使用"),
                _c(
                  "span",
                  { staticStyle: { color: "#ec1c1c", "font-weight": "600" } },
                  [_vm._v("1")]
                ),
                _vm._v("次,\n          链接有效期"),
                _c(
                  "span",
                  { staticStyle: { color: "#ec1c1c", "font-weight": "600" } },
                  [_vm._v("10")]
                ),
                _vm._v("分钟\n          "),
                _c(
                  "span",
                  { staticClass: "refresh", on: { click: _vm.refreshCode } },
                  [_vm._v("重新获取")]
                )
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "res-title" }, [
      _c("img", {
        staticStyle: { width: "25px", margin: "0 1%" },
        attrs: { src: "/images/pc_enterprise.png", alt: "qiye" }
      }),
      _vm._v("授权申请")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12f6eef2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12f6eef2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/auth/APIAuth/AuthRes/AuthResult.vue
// module id = MtBH
// module chunks = 151